import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { OrcamentoService } from '../../../../providers/orcamento-service';

@Component({
    selector: 'page-modal-pv-orcamento',
    templateUrl: 'modal-pv-orcamento.html'
})
export class ModalPreVisualizarOrcamentoPage {
    titulo: any;
    isJurisdicionado: any;
    listaDados: any;
    listaDadosBaixa: any = [];
    listaDadosReincidencia: any = [];
    listaDadosOutros: any = [];
    dataGeracao: any;
    loading: boolean = true;
    shownGroup: any = [];

    constructor(private viewCtrl: ViewController,
        public navParams: NavParams,
        public orcamentoService: OrcamentoService,
        public alertCtrl: AlertController,
        public gestaoPcaService: GestaoPcaService) {

        this.dataGeracao = new Date();

        this.listarDados();
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    listarDados() {
        this.orcamentoService.obterPreviewCertificado().subscribe(
            data => {
                this.listaDados = data;

                this.loading = false;
            }, error => {
                console.log("erro: " + error);
                this.loading = false;
            }
        );
    }

    //  #region Métodos do Accordion
    toggleGroup(group) {
        if (this.isGroupShown(group)) {
            let index = this.shownGroup.indexOf(group);
            this.shownGroup.splice(index, 1);
        } else {
            this.shownGroup.push(group);
        }
    }

    isGroupShown(group) {
        return this.shownGroup.indexOf(group) != -1;
    };

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    formatarPorcentagem(valor) {
        return valor.toString().replace('.', ',') + "%";
    }

    calculaExecOrca(emp, dot)
    {
        let calc = (emp / dot) * 100;

        if(isNaN(calc)) calc = 0;

        return this.formatarValorNumerico(calc);
    }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pre-visualizacao/orcamento/modal-pv-orcamento.ts